module.exports = __webpack_public_path__ + "img/bg2.6846304e.png";